// Sign In: the unauthenticated landing (HOP-38 routing).

import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useNavigate } from 'react-router-dom'
import { Grain } from '@/components/hs/Grain'
import '@/styles/auth-pages.css'

export function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()
  const navigate = useNavigate()

  if (isAuthenticated && !isLoading) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="hs-brand auth-page">
      <Grain opacity={0.06} />

      <div className="auth-page__topbar">
        <div className="auth-brand-lockup">
          <span className="auth-brand-mark" />
          <span className="auth-brand-name">Hopscotch</span>
        </div>
      </div>

      <div className="auth-page__centered">
        <div className="auth-page__center-card auth-page__center-card--login">
          <div className="auth-eyebrow auth-page__mini-eyebrow">
            Welcome back
          </div>
          <h1 className="auth-heading auth-heading--login">
            Good to see you.
          </h1>
          <p className="auth-copy auth-copy--login">
            Sign in to pick up where you and your reader left off.
          </p>

          <button
            type="button"
            onClick={() => loginWithRedirect()}
            disabled={isLoading}
            className="hs-press auth-submit-button auth-submit-button--login"
          >
            {isLoading ? 'Loading...' : 'Sign in'}
          </button>

          <p className="auth-switch-copy auth-switch-copy--login">
            New to Hopscotch?{' '}
            <button
              type="button"
              onClick={() => navigate('/auth/signup')}
              className="auth-link-button"
            >
              Create an account
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}
